import React from "react";
import { Modal, Button } from "react-bootstrap";

const SuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;  // Si el modal no está abierto, no se renderiza nada

  return (
    <div className="modal show" style={{ display: 'block' }} onClick={onClose}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">¡Éxito!</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p>La obra ha sido registrada exitosamente.</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


export default SuccessModal;
